import React from 'react'

const LineIcon = () => {
  return (
    <svg
      className='fill-current'
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='facebook'>
        <path
          id='shape'
          d='M13 22.7299H9C8.73478 22.7299 8.48043 22.6246 8.29289 22.437C8.10536 22.2495 8 21.9952 8 21.7299V15.5299H6C5.73478 15.5299 5.48043 15.4246 5.29289 15.237C5.10536 15.0495 5 14.7952 5 14.5299V10.9299C5 10.6647 5.10536 10.4104 5.29289 10.2228C5.48043 10.0353 5.73478 9.92993 6 9.92993H8V8.22994C8.0701 6.70629 8.74062 5.27238 9.86497 4.24172C10.9893 3.21107 12.476 2.66752 14 2.72993H17C17.2652 2.72993 17.5196 2.83529 17.7071 3.02283C17.8946 3.21036 18 3.46472 18 3.72993V7.32994C18 7.59515 17.8946 7.84951 17.7071 8.03704C17.5196 8.22458 17.2652 8.32994 17 8.32994H14V9.92993H17C17.1544 9.92877 17.307 9.96337 17.4458 10.031C17.5846 10.0987 17.7058 10.1976 17.8 10.3199C17.8931 10.4441 17.9561 10.5883 17.9839 10.741C18.0116 10.8938 18.0035 11.0509 17.96 11.1999L16.96 14.7999C16.8995 15.0162 16.768 15.2059 16.5866 15.3383C16.4052 15.4707 16.1844 15.5382 15.96 15.5299H14V21.7299C14 21.9952 13.8946 22.2495 13.7071 22.437C13.5196 22.6246 13.2652 22.7299 13 22.7299ZM10 20.7299H12V14.5299C12 14.2647 12.1054 14.0104 12.2929 13.8228C12.4804 13.6353 12.7348 13.5299 13 13.5299H15.24L15.68 11.9299H13C12.7348 11.9299 12.4804 11.8246 12.2929 11.637C12.1054 11.4495 12 11.1952 12 10.9299V8.22994C12.0257 7.71702 12.2477 7.23364 12.62 6.87993C12.9923 6.52623 13.4864 6.32929 14 6.32993H16V4.72993H14C13.0068 4.66942 12.0298 5.00297 11.281 5.6582C10.5321 6.31343 10.0719 7.2375 10 8.22994V10.9299C10 11.1952 9.89464 11.4495 9.70711 11.637C9.51957 11.8246 9.26522 11.9299 9 11.9299H7V13.5299H9C9.26522 13.5299 9.51957 13.6353 9.70711 13.8228C9.89464 14.0104 10 14.2647 10 14.5299V20.7299Z'
        />
      </g>
    </svg>
  )
}

export default LineIcon
